import gsap, { Power1, Power2, Power3 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';

class ScrollItem__BillboardProject extends Scroll_Item {
  _mode = "intro";
  
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._itemsShow = [
      GetBy.class("__t1", this.item)[0],
      GetBy.class("__t2", this.item)[0],
      GetBy.class("__t3", this.item)[0],
      GetBy.class("__t5", this.item)[0],
      GetBy.class("__t4", this.item)[0]
    ];

    console.log(this._itemsShow)

    /*this._intro = GetBy.class('header-page', __link)[0];
    this._content = GetBy.class('content', __link)[0];
    this._insight = GetBy.class('insight', this._content)[0];
    this._description = GetBy.class('description', this._content)[0];*/

    this.onShow = () => { this.showIntro(); }
  }

  showIntro() {
    let delay = .5;
    let inc = .1;
    let time = .2;

    for(let i=0,j=this._itemsShow.length; i<j; i++) {

      if(i < j-2) {
        const item = this._itemsShow[i];
        delay = delay + inc * i;
        gsap.to(item, {opacity:1, duration:time, delay: delay});
      
      } else {
        delay = delay + .3;

        let distance = Maths.maxminRandom(Metrics.WIDTH * .009, Metrics.WIDTH * .007);
        const offset = {
          x: Math.random() > .5 ? 1 : -1,
          y: Math.random() > .5 ? -1 : 1
        }

        gsap.killTweensOf(item);
        gsap.set(item, { x: offset.x * distance * 2, y: offset.y * distance, force3D: true });

        gsap.to(item, { x: 0, duration: .3, delay: delay, ease: Power3.easeOut });
        gsap.to(item, { y: 0, duration: .4, delay: delay + .1, ease: Power3.easeInOut });
       // gsap.to(item, { opacity: 1, duration: .1, delay: delay, ease: Power2.easeIn });
       // time = .2;
      }
    }

    //

   /* gsap.killTweensOf(this._content);
    gsap.killTweensOf(this._intro);
    gsap.killTweensOf(this._insight);
    gsap.killTweensOf(this._description);

    this._intro.style.pointerEvents = "all";
  
    gsap.to(this._intro, {"--opacity":1, duration: .2, ease:Power2.easeOut})
    gsap.to(this._content, {"--opacity":1, duration: .2, ease:Power2.easeOut})
    gsap.to(this._insight, {"--opacity":1, duration: .3, delay:.1, ease:Power2.easeOut})
    gsap.to(this._description, {"--opacity":1, duration: .3, delay:.2, ease:Power2.easeOut})*/
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
}

Scroll._registerClass('billboard-project', ScrollItem__BillboardProject);
